"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_image_1 = require("@hotelplan/components.common.image");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const NotificationInfo = styled_components_1.default.div.attrs({
    'data-id': `info-notification`,
})(({ theme }) => theme.notifications.notificationInfo || {});
const NotificationIcon = (0, styled_components_1.default)(components_common_image_1.Image).attrs({ 'data-id': `content` })((0, util_theme_sxc_1.sx2CssThemeFn)({
    mx: 2,
}));
const NotificationInfoContent = styled_components_1.default.div.attrs({
    'data-id': `content`,
})(({ theme }) => theme.notifications.notificationInfoContent || {});
const InfoNotification = ({ mainText, icon, }) => {
    return (react_1.default.createElement(NotificationInfo, null,
        icon && (react_1.default.createElement(NotificationIcon, Object.assign({}, icon, { lazy: false, width: "20", height: "20" }))),
        mainText ? (react_1.default.createElement(NotificationInfoContent, { dangerouslySetInnerHTML: { __html: mainText } })) : null));
};
exports.default = InfoNotification;
//# sourceMappingURL=InfoNotification.js.map